/** 发布必填项检查模块 */
import React, { memo, useState, useMemo, useEffect, useCallback, useRef } from 'react';
import {
  Text,
  Progress,
  CollapseTransition,
  useOutsideClick,
  Bubble,
  Button,
} from '@tencent/tea-component';
import CheckList from './checkList';
// import { useStore } from '@utils/event-store/useEventData';
import classNames from 'classnames';
import './index.scss';
interface Props {
  /** 发布模块数据 */
  data: any[];
  /** 进度条数据 */
  percent: string;
  /**
   * 当前模式
   * mode 1 平铺模式 2 弹框模式
   * @default 1
   * */
  mode?: 1 | 2;
  /**
   * 是否显示收起按钮
   *  */
  showUp?: boolean;
  /**
   * 默认列表展示
   */
  defautShow?: boolean;
  /**
   * 弹框是否显示
   * 仅mode=2时存在
   * @default false
   */
  modalVisible?: boolean;
  /**
   *  是否显示发布列表小动画
   * @default false
   */
  listTranslation?: boolean;
  /**
   * 是否在引导状态
   * @default false
   */
  isInGuideStatus?: boolean;
  /** 是否显示切换tips */
  isShowChangeList?: boolean;
  /** 引导状态 点击按钮回调 */
  clickBtn?: Function;
  /** 点击进度条和标题的回调 */
  callback?: Function;
  /** 动画之后点击收起的回调*/
  closeAnimationCallback?: Function;
  /** 关闭切换准入提示回调 */
  closeChangeTips?: Function;
}
const PublichCheck = (props: Props) => {
  const {
    data,
    percent,
    mode = 1,
    showUp = false,
    modalVisible = false,
    listTranslation = false,
    isInGuideStatus = false,
    defautShow = true,
    isShowChangeList = false,
    clickBtn,
    callback,
    closeAnimationCallback,
    closeChangeTips,
  } = props;
  /** 当前选中行 */
  const [isSelectItem, updateItem] = useState(-1);
  /** 当前选中行 详情 */
  const selectItem = useMemo(() => data[isSelectItem], [data, isSelectItem]);
  /** 当前默认展开状态 */
  const [isShow, setShow] = useState(defautShow);
  /** 当前获取进度 */
  // const { dispatch  } = useStore();
  /** 当前第一次变化default */
  const [isFirstShow, updateFirst] = useState(true);
  /** 变更展开状态 */
  const updateShowStatus = useCallback(
    (e) => {
      if (!showUp) return;
      e?.stopPropagation();
      closeChangeTips?.();
      setShow(!isShow);
      updateFirst(false);
      callback?.();
    },
    [isShow, showUp, closeChangeTips],
  );
  // 默认选中第一个未完成项
  useEffect(() => {
    if (!data) return;
    let sleceted = data?.findIndex((item) => !item?.isEdit);
    if (sleceted < 0) sleceted = data?.length - 1;
    updateItem(sleceted);
  }, [data]);
  // 根据默认状态显示
  useEffect(() => {
    setShow(defautShow);
    updateFirst(true);
  }, [defautShow]);
  if (mode === 2) {
    /** 当前为弹框时监听点击外部收起 */
    const modalContent = useRef(null);
    /** 透传预览模态框 */
    const previewModal = useRef(null);
    const listModal = useRef(null);
    const tipBubble = useRef(null);
    const { listen } = useOutsideClick([modalContent, listModal, previewModal, tipBubble]);
    listen(() => {
      if (isShowChangeList) closeChangeTips?.();
      setShow(false);
    });
    useEffect(() => {
      if (listTranslation && modalVisible) setShow(true);
    }, [listTranslation, modalVisible]);
    useEffect(() => {
      if (isShowChangeList) setShow(isShowChangeList);
    }, [isShowChangeList]);
    /** 动画之后的关闭方法回调 */
    useEffect(() => {
      if (listTranslation && !isShow) closeAnimationCallback?.();
    }, [listTranslation, isShow]);
    return (
      <div className={classNames('publish-check-box_modal publish-check-box')}>
        <div
          ref={modalContent}
          onClick={updateShowStatus}
          className="publish-check-box_modal_title"
        >
          <Text
            parent={'div'}
            className={classNames('publish-check-box-title', {
              'cursor-pointer': showUp,
            })}
          >
            发布必填检查表
            {showUp && (
              <i className={`iconfont ${isShow ? 'icon-arrow-up' : 'icon-arrow-down'}`}></i>
            )}
          </Text>
          {percent ? (
            <Progress
              percent={Number(percent)}
              strokeColor="#FFD934"
              strokeWidth={8}
              className="ma-menu_link-progress"
            />
          ) : (
            <div className="progress-none"></div>
          )}
        </div>
        <div
          className={classNames('check-list_modal-box', {
            'check-list_modal-isTranslation': isShow,
            'check-list_modal-isTranslationOut': !isShow && !isFirstShow,
          })}
          ref={listModal}
        >
          <Bubble
            className="yellow-tips change-proccess-buuble"
            placement="right-end"
            visible={isShowChangeList}
            ref={tipBubble}
            content={
              isShowChangeList ? (
                <>
                  <div className="bubble-title">发布必填检查表变更</div>
                  <div className="bubble-content">因准入方式发生变化，活动发布必填步骤已变更</div>
                  <Button
                    className="size-xs bubble-button"
                    type="primary"
                    onClick={() => closeChangeTips?.()}
                  >
                    知道了
                  </Button>
                </>
              ) : undefined
            }
          >
            <CheckList
              className={classNames('check-list_modal', {
                'check-list_modal__translation': listTranslation && isShow,
              })}
              mode={mode}
              data={data}
              isSelectItem={isSelectItem}
              onSelect={(item: any, index: number) => {
                console.log(item);
                updateItem(index);
              }}
              callback={() => {
                setShow(false);
                closeChangeTips?.();
              }}
              previewRef={previewModal}
              isHidePreview={!isShow}
            />
          </Bubble>
        </div>
      </div>
    );
  }
  return (
    <div
      className={classNames('publish-check-box', {
        'is-guide-publish-box': isInGuideStatus,
      })}
    >
      <div className="publish-check-box-content_left">
        <Text
          parent={'div'}
          className={classNames('publish-check-box-content_left-title publish-check-box-title', {
            'cursor-pointer': showUp,
          })}
          onClick={updateShowStatus}
        >
          发布必填检查表
          {showUp && <i className={`iconfont ${isShow ? 'icon-arrow-up' : 'icon-arrow-down'}`}></i>}
        </Text>
        <CollapseTransition in={isShow} timeout={500} height={1000}>
          <div>
            {percent ? (
              <Progress
                percent={Number(percent)}
                strokeColor="#FFD934"
                strokeWidth={8}
                className="ma-menu_link-progress"
              />
            ) : (
              <div className="progress-none"></div>
            )}
            <CheckList
              data={data}
              isSelectItem={isSelectItem}
              clickBtn={clickBtn}
              isInGuideStatus={isInGuideStatus}
              onSelect={(item: any, index: number) => {
                console.log('item', item);
                if (isInGuideStatus) {
                  clickBtn?.();
                  return;
                }
                updateItem(index);
              }}
            />
          </div>
        </CollapseTransition>
      </div>
      <div
        className={classNames('check-selected-image', {
          ['image-is-show']: isShow,
          ['image-is-hidden']: !isShow,
        })}
      >
        <p className="check-selected-desc-box">{selectItem?.desc}</p>
        {selectItem?.src ? <img src={selectItem?.src} /> : <></>}
      </div>
    </div>
  );
};
export default memo(PublichCheck);
